"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unfoldProject;
const either_1 = require("../../../../types/either");
function unfoldProject(project, printableId, layerId) {
  const printableGroupIndex = project.printableGroups.findIndex(pg => !!pg.printables.find(p => p.id === printableId));
  if (printableGroupIndex === -1) {
    return (0, either_1.left)(new Error(`Could not find printable group  - printableId: ${printableId}`));
  }
  const printableIndex = project.printableGroups[printableGroupIndex].printables.findIndex(p => p.id === printableId);
  if (printableIndex === -1) {
    return (0, either_1.left)(new Error(`Could not find printable for printableId: ${printableId}`));
  }
  const layerIndex = project.printableGroups[printableGroupIndex].printables[printableIndex].layers.findIndex(layer => layer.id === layerId);
  if (layerIndex === -1) {
    return (0, either_1.left)(new Error(`Could not find layer for layerId: ${layerId}`));
  }
  return (0, either_1.right)({
    printableGroup: project.printableGroups[printableGroupIndex],
    printable: project.printableGroups[printableGroupIndex].printables[printableIndex],
    layer: project.printableGroups[printableGroupIndex].printables[printableIndex].layers[layerIndex]
  });
}